// extracted by mini-css-extract-plugin
export default {"container":"leftmenu_container__2OuZL","collapsed":"leftmenu_collapsed__A54zd"};